<script>
import { BButtonClose } from "bootstrap-vue";

export default {
  extends: BButtonClose
};
</script>